var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "g105",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.2,
    height: 17.2,
    viewBox: "0 0 19.2 17.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g107",
    transform: "translate(0.6 0.6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g109"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g115",
    transform: "translate(3.939 4.979)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path117",
    d: "M14.442,4.96V9.277c0,.674-2.266,1.622-5.061,1.622S4.32,9.951,4.32,9.277V4.96",
    transform: "translate(-4.32 -4.96)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g119"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path121",
    d: "M9.6,7.475.6,4.026,9.6.6l9,3.426Z",
    transform: "translate(-0.6 -0.6)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g123",
    transform: "translate(16.655 4.066)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path125",
    d: "M16.33,4.16v6.692",
    transform: "translate(-16.33 -4.16)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g127",
    transform: "translate(15.533 10.758)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path129",
    d: "M17.515,11.231a1.126,1.126,0,1,1-1.122-1.211A1.169,1.169,0,0,1,17.515,11.231Z",
    transform: "translate(-15.27 -10.02)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g131",
    transform: "translate(16.655 13.191)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path133",
    d: "M16.33,12.15v2.809",
    transform: "translate(-16.33 -12.15)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCap);
export default __webpack_public_path__ + "static/media/Cap.ee46f01929e2d60c1e0b87c4a314b74e.svg";
export { ForwardRef as ReactComponent };